import { Directive, ElementRef, HostListener, Input } from "@angular/core";

// TODO: alterar para tratar o imgFallBack com base em tipo ao invés de receber a url completa e usar a pasta de assets local
@Directive({
  selector: "[appImgFallback]",
  standalone: true,
})
export class ImgFallbackDirective {
  @Input() appImgFallback!: string;

  constructor(private el: ElementRef<HTMLImageElement>) {}

  @HostListener("error")
  onError(): void {
    const img: HTMLImageElement = this.el.nativeElement;
    if (img.src !== this.appImgFallback) {
      img.src = this.appImgFallback;
    }
  }
}
